import Vue from 'vue'

Vue.filter('addZero', function(val) {
    if(val.toString().length < 2){
        return "0" +val
       }else{
        return val
       }
   })

Vue.filter('toWeek', function(index) {
    const weeks = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六']
    const length = weeks.length
    if( 0 < +index < length){
        return weeks[index]
    }else{
        return index
    }
   })   

Vue.filter('toDate', function(time,type) {
    var array =  time.split(type);
    var date = new Date(array[0], array[1]-1, array[2]);
    return date
})   
  
Vue.filter('format', function(date,type) {
    var year = date.getFullYear();
    var month = this.$vue.filter("addZero")(date.getMonth() + 1);
    var day = this.$vue.filter("addZero")(date.getDate());
    var time = year + type + month + type +day
    return time
})  